import { toNormalizedFrequency } from './frequencyMap';

type NormalizedFrequency = 'WEEK' | 'FORTNIGHT' | 'MONTH' | 'QUARTER' | 'YEAR';

// Periods per year for each normalized frequency
const PERIODS_PER_YEAR: Record<NormalizedFrequency, number> = { WEEK: 52, FORTNIGHT: 26, MONTH: 12, QUARTER: 4, YEAR: 1 };

export function calculateTotals(amount: number | null | undefined, frequencyFrom: string, frequencyTo: string): number {
  if (!amount && amount !== 0) return 0;

  const from = toNormalizedFrequency(frequencyFrom) as NormalizedFrequency;
  const to = toNormalizedFrequency(frequencyTo) as NormalizedFrequency;

  if (from === to) return amount;

  const yearly = amount * PERIODS_PER_YEAR[from];
  return yearly / PERIODS_PER_YEAR[to];
}
